(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal: our own blocks plus Horizon product cards */
  function setupReveal() {
    var targets = document.querySelectorAll('.tmp-reveal, main product-card');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el, i) {
      if (el.tagName === 'PRODUCT-CARD') {
        el.classList.add('tmp-reveal');
        el.style.transitionDelay = (i % 4) * 90 + 'ms';
      }
      io.observe(el);
    });
  }

  /* Paw-print trail that follows the mouse (desktop only) */
  function setupPawTrail() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    var last = 0, lastX = 0, lastY = 0, side = 1;
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      if (now - last < 110 || dx * dx + dy * dy < 1600) return;
      last = now;
      var angle = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      var offset = 8 * side; side *= -1;
      var rad = (angle) * Math.PI / 180;
      var paw = document.createElement('span');
      paw.className = 'tmp-paw-print';
      paw.style.left = e.clientX + Math.cos(rad) * offset + 'px';
      paw.style.top = e.clientY + Math.sin(rad) * offset + 'px';
      paw.style.setProperty('--r', angle + 'deg');
      document.body.appendChild(paw);
      setTimeout(function () { paw.remove(); }, 1400);
      lastX = e.clientX; lastY = e.clientY;
    }, { passive: true });
  }

  /* Little heart burst when someone clicks add to cart or a main button */
  function setupHearts() {
    if (reduce) return;
    var icons = ['❤️', '🐾', '🦴', '✨'];
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"], .add-to-cart-button, .tmp-btn, button[type="submit"]');
      if (!btn) return;
      for (var i = 0; i < 7; i++) {
        var h = document.createElement('span');
        h.className = 'tmp-heart';
        h.textContent = icons[i % icons.length];
        h.style.left = e.clientX + 'px';
        h.style.top = e.clientY + 'px';
        h.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
        h.style.setProperty('--rot', (Math.random() * 60 - 30) + 'deg');
        h.style.animationDelay = i * 40 + 'ms';
        document.body.appendChild(h);
        (function (node) { setTimeout(function () { node.remove(); }, 1300); })(h);
      }
    });
  }

  function init() { setupReveal(); setupPawTrail(); setupHearts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', setupReveal);
})();
